module.exports = __webpack_public_path__ + "static/media/order-onway.7973c186.gif";